import React from 'react'
import { LabraToolTip, LabraToolTipV2 } from '@labrav/react-components'
import { truncateString } from '@labrav/common'

export type ShortenedNameProps = {
  name: string
  length?: number
  tooltipPlacement?: React.ComponentProps<
    typeof LabraToolTipV2
  >['tooltipPlacement']
  isV2?: boolean
}

export const ShortenedName = React.memo(
  ({
    name,
    length = 12,
    tooltipPlacement = 'top',
    isV2 = false,
  }: ShortenedNameProps) => {
    if (typeof name !== 'string' || typeof length !== 'number') {
      return null
    }
    return isV2 && name.length > 12 ? (
      <LabraToolTipV2 label={name} tooltipPlacement={tooltipPlacement}>
        <div data-testid="shortened-name">{truncateString(name, length)}</div>
      </LabraToolTipV2>
    ) : name.length > 12 ? (
      <LabraToolTip label={name} tooltipPlacement={tooltipPlacement}>
        <div data-testid="shortened-name">{truncateString(name, length)}</div>
      </LabraToolTip>
    ) : (
      <div data-testid="shortened-name">{name}</div>
    )
  }
)
